import {addEvent} from 'fmjs';

export const triggerResize = () => {
  window.dispatchEvent(new Event('resize'));
};

const trigger = () => {
  setTimeout(triggerResize, 200);
};

export const init = () => {
  addEvent(window, 'load', trigger);
};
